import { defineComponent, unref, resolveComponent, computed } from 'vue';import { useStore } from 'vuex';import { useRouter } from 'vue-router';import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-ed094a18"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-nav"
};
const _hoisted_2 = {
  class: "menu-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_4 = {
  key: 0,
  class: "menu-module"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  key: 0,
  class: "display-start"
};
const _hoisted_7 = {
  class: "el-dropdown-link display-start"
};
const _hoisted_8 = {
  class: "display-start"
};
const _hoisted_9 = {
  key: 0,
  class: "user-name"
};
const _hoisted_10 = {
  key: 1,
  class: "menu-box"
};
import { getNavAndLeftMenuData } from '@/utils/menu';
import { ArrowDown } from '@element-plus/icons-vue';
import { useUserInfo } from '@/hooks/useUserInfo';
import { useChannel } from '@/hooks/useChannel';
import { ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message-box/style/index'

import { themeColor } from '@/utils/theme';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      getters,
      state,
      commit,
      dispatch
    } = useStore();
    const token = state.moduleCommon.token;
    // 获取导航数据
    const navMenuArr = computed(() => {
      // 判断用户是否登录
      if (!token) {
        return [];
      }
      let res = [];
      const allMenuList = getters['moduleCommon/getNavMenuArr'];
      if (Array.isArray(allMenuList)) {
        res = allMenuList.filter(menu => !menu.hide);
      }
      return res;
    });
    // 隐藏头部信息
    const sideStatus = computed(() => getters['moduleCommon/getSideStatus']);
    const activedId = computed(() => state.moduleCommon.navActived);
    // 获取当前用户的初始值
    const {
      userInfo
    } = useUserInfo();
    // 显示名称
    const showName = () => {
      if (userInfo.value?.isAdmin === '0') {
        return true;
      } else {
        return userInfo.value?.authenticated;
      }
    };
    // 判断选中
    const modifyActived = item => {
      if (!token) {
        return '';
      }
      let resCalss = ''; // 返回的样式值
      if (item.moduleKey === 'myAccountAllData') {
        resCalss = 'my-account';
      }
      if (item.moduleKey === activedId.value) {
        // 判断当前模块是否选中
        if (item.moduleKey === 'myAccountAllData') {
          resCalss = 'my-account-actived';
        } else {
          resCalss = 'actived';
        }
      }
      return resCalss;
    };
    // 点击事件
    const handleSelect = key => {
      getNavAndLeftMenuData({
        moduleKey: key
      });
      commit('moduleCommon/NAV_ACTIVED', key);
    };
    const router = useRouter();
    // 退出账户
    const signOut = () => {
      ElMessageBox.confirm('确定进行【退出账户】操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        dispatch('moduleCommon/logout');
      });
    };
    // 修改密码
    const toResetPw = () => {
      router.push({
        name: 'changePassword'
      });
    };
    // 前往个人信息
    const toUserInfo = () => {
      router.push({
        name: 'personalInformation'
      });
    };
    // 切换主题色
    const changeThemeColor = theme => {
      let useTheme = '';
      if (Object.prototype.hasOwnProperty.call(themeColor, theme)) {
        useTheme = theme;
      } else {
        useTheme = 'theme-base';
      }
      commit('moduleCommon/USE_THEME', useTheme);
      const themeOptions = themeColor[useTheme];
      Object.keys(themeOptions).forEach(key => {
        document.documentElement.style.setProperty(`--${key}`, themeOptions[key]);
      });
    };
    // changeThemeColor(state.moduleCommon.useTheme)
    // 前往个人信息
    const toLogin = () => {
      router.push({
        path: '/login'
      });
    };
    const {
      datangChannel
    } = useChannel();
    // 判断是否展示
    const isShow = computed(() => {
      return !datangChannel();
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _unref(userInfo)?.firstUnsubmitInvestAcctType === 99 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navMenuArr), item => {
        return _openBlock(), _createBlock(_component_el_button, {
          key: item.moduleKey,
          type: "danger",
          link: "",
          class: _normalizeClass(modifyActived(item)),
          onClick: $event => handleSelect(item.moduleKey)
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": item.icon
          }, null, 8, ["icon-class"]), _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1)]),
          _: 2
        }, 1032, ["class", "onClick"]);
      }), 128))])) : _createCommentVNode("", true)]), _unref(sideStatus) && _unref(token) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_createVNode(_component_svg_icon, {
        "icon-class": "user"
      }), _createElementVNode("span", null, "欢迎您，" + _toDisplayString(_unref(userInfo)?.isAdmin !== '0' ? '管理员' : ''), 1)]), _createVNode(_component_el_dropdown, {
        placement: "bottom"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_unref(userInfo)?.authenticated || _unref(userInfo)?.isAdmin === '0' ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 0,
            onClick: toUserInfo
          }, {
            default: _withCtx(() => [_createTextVNode("个人信息")]),
            _: 1
          })) : _createCommentVNode("", true), _unref(userInfo)?.isOpen ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 1,
            onClick: toResetPw
          }, {
            default: _withCtx(() => [_createTextVNode("修改密码")]),
            _: 1
          })) : _createCommentVNode("", true), _unref(isShow) ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 2,
            onClick: signOut
          }, {
            default: _withCtx(() => [_createTextVNode("退出账户")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_8, [showName() ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(userInfo)?.nickname), 1)) : _createCommentVNode("", true), _createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })])]),
        _: 1
      })])) : _createCommentVNode("", true), !_unref(token) && _unref(sideStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", {
        onClick: toLogin,
        class: "active"
      }, [_createVNode(_component_svg_icon, {
        "icon-class": "aboutuser@2x",
        class: "eye-icon"
      }), _createTextVNode("投资通登录")])])) : _createCommentVNode("", true)]);
    };
  }
});